import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import config from '../../app/config';
import { color } from '../../app/theme';
import Button from '../shared/Button';

const useStyles = makeStyles(
  () => ({
    root: {},
    paper: {
      width: 960,
      maxWidth: 'unset',
      borderRadius: 12,
      boxShadow:
        '0 30px 66px 0 rgba(0, 0, 0, 0.09), 0 8px 58px 0 rgba(0, 0, 0, 0.05)',
      backgroundColor: color.$7,
    },
    title: {
      padding: 24,
      '& > h2': {
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '20px',
        color: color.$3,
        textAlign: 'center',
      },
    },
    content: {
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: 'normal',
      color: color.$3,
      padding: 24,
      background: color.$19,
    },
    actions: {
      background: color.$19,
      padding: '0 24px 24px',
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      '& > a': {
        color: color.$2,
        textDecorationLine: 'underline',
        margin: '0 4px',
      },
    },
  }),
  {
    name: 'CheckProductModal',
  },
);

function CheckProductModal({
  isOpen,
  onCancel,
  name = 'checkInsightArkProductModal',
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogTitle className={classes.title}>{t(`${name}.title`)}</DialogTitle>
      <DialogContent className={classes.content}>
        <div>{t(`${name}.content`)}</div>
        <br />
        <div>{t(`${name}.content1`)}</div>
        <div>{t(`${name}.content2`)}</div>
        <br />
        <div className={classes.flex}>
          {t(`${name}.content3`)}
          <a
            href={`${config.CONSOLE_URL}/account-setting/plan-info`}
            rel="noopener noreferrer"
          >
            {t(`${name}.content4`)}
          </a>
          {t(`${name}.content5`)}
        </div>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button topic="primaryBlueHighLight" onClick={onCancel}>
          {t(`${name}.cancel`)}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CheckProductModal;
